export const iconFontAwesomeMoneyCruzeiroSign = (
	<i className="fa-solid fa-cruzeiro-sign"></i>
);
